import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Site } from '@debbie/common/dist/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import * as workflowsAPI from '@debbie/cortex/dist/api/workflows.js';
import { selectUpdateTypesMap } from '@debbie/cortex/dist/update-types/selectors.js';
import Button from '../Button.js';
const TaskButtons = (props) => {
    const updateTypesMap = useSelector(selectUpdateTypesMap);
    const { tasks, case: _case } = props;
    return (React.createElement(React.Fragment, null, tasks.map((task) => {
        const updateType = updateTypesMap[task.updateTypeId];
        if (!updateType)
            return null;
        return (React.createElement(TaskButton, { key: task.id, updateType: updateType, case: _case, task: task }));
    })));
};
const TaskButton = (props) => {
    const { updateType, case: _case, task } = props;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const [loading, setLoading] = useState(false);
    if (Site.Client == site && updateType.responsiblePermissionLevel != 'client')
        return null;
    return (React.createElement(Button, { blockOnMobile: true, size: "small", loading: loading, onClick: async () => {
            try {
                setLoading(true);
                if (_case.workflowId) {
                    await workflowsAPI.runTask(_case.workflowId, _case.caseId, task.id);
                    c.cases.getUpdates(_case.caseId);
                }
            }
            catch (error) {
                alert(error);
                console.error(error);
            }
            setLoading(false);
        } }, lang.updateTypes[updateType.updateTypeId] || updateType.label));
};
export default TaskButtons;
//# sourceMappingURL=TaskButtons.js.map